import Select from "react-select";
import {isMobile} from "react-device-detect";
import {MultipleSelectModal} from "../../PrettySelect/MultipleSelectModal";
import React from "react";
import { useTranslations, useLocale } from 'next-intl'

const SelectiveMultipleInput = ({ name, id, addEstate, isHomePage, handleSelectedItems, disabled, value= [], onChange, options }: any) => {
    const t = useTranslations('')
    const currentLanguage = useLocale();
    const transformedData = options.map((item: any) => ({
        value: item.value,
        label: item.translations[currentLanguage].name
    }));

    return (
        <div className="mb-3">
            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            {(!isMobile || !isHomePage) &&
                <Select
                    className="custom-select-box-design"
                    value={
                        transformedData.filter((option: any) => {
                            return value.includes(option.value);
                        })
                    }
                    isMulti={true}
                    closeMenuOnSelect={false}
                    blurInputOnSelect={false}
                    onChange={onChange}
                    placeholder={name}
                    name={id}
                    options={transformedData}
                    isDisabled={disabled}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: '#e8e8e8',
                            fontSize: '14px',
                            color: '#212529',
                            borderRadius: '8px',
                        }),
                        multiValue: (styles, {data}) => {
                            return {
                                ...styles,
                                borderRadius: '12px',
                                fontSize: '13px'
                            };
                        },

                        multiValueRemove: (styles, {data}) => ({
                            ...styles,
                            ':hover': {
                                backgroundColor: 'inherit',
                                borderRadius: '12px',
                                color: 'white',
                            },
                        }),
                    }}
                />
            }
            {(isMobile && isHomePage) &&
                <MultipleSelectModal options={transformedData}
                                     name={id}
                                     placeholder={name}
                                     onSelectionApply={handleSelectedItems}/>
            }
        </div>
    )
};
export default SelectiveMultipleInput;
